import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import AppInput from '../../../../common/AppInput';
import Message from '../../../../common/Message';
import MotiveTitle from '../../../Contact/Motive/MotiveTitle';
import { INFO_GO_MY_ACCOUNT_CHANGE_PASS } from '../../../../../constants/texts';
import { useChagePassStyles } from './styles';
import { COMPLETE_FORM } from '../../../../../constants/texts';
import { textMapper } from '../../../../../helpers/FormHelper';
import { resetGet } from '../../../../../redux/slices/ValidationDniSlice';

const Form = ({ ...props }) => {
  const { state, onData, mobile, motiveId, fields } = props;
  const classes = useChagePassStyles({ mobile });
  const reduxDispatch = useDispatch();

  const handleChange = (e) => {
    onData({ name: e.target.name, value: e.target.value });
  };

  useEffect(() => {
    reduxDispatch(resetGet());
  }, [resetGet]);

  return (
    <React.Fragment>
      <MotiveTitle
        title={textMapper.get(motiveId).title}
        subtitle={textMapper.get(motiveId).subtitle}
        icon={textMapper.get(motiveId).icon}
        mobile={mobile}
      />

      <Message
        severity="info"
        message={INFO_GO_MY_ACCOUNT_CHANGE_PASS}
        fullRounded
      />

      <Typography className={classes.title}>{COMPLETE_FORM}</Typography>

      {fields.map((field, index) => (
        <AppInput
          key={index}
          onChange={handleChange}
          onBlur={() => {}}
          onClick={() => {}}
          disabled={state[field.name]?.disabled || false}
          name={field.name}
          error={state[field.name]?.error || false}
          type={state[field.name]?.type || ''}
          label={state[field.name]?.label || ''}
          required={state[field.name]?.required || false}
          inputAdornment={state[field.name]?.inputAdornment || ''}
          success={state[field.name]?.success || false}
          helperText={state[field.name]?.helper || ''}
          multiline={state[field.name]?.multiline || false}
          rows={state[field.name]?.rows || ''}
          value={state[field.name]?.value || ''}
          errorMessage={state[field.name]?.message || ''}
        />
      ))}
    </React.Fragment>
  );
};

Form.propTypes = {
  state: PropTypes.object,
  onData: PropTypes.func,
  mobile: PropTypes.bool,
  motiveId: PropTypes.string,
  fields: PropTypes.array,
};

export default Form;
